module.exports = __webpack_public_path__ + "static/media/hand.060255bf.svg";